import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, BadgeCheck } from 'lucide-react';
const testimonials = [{
  quote: 'Desde el día 3 ya me sentía diferente. Nunca pensé que cambios tan simples harían tanta diferencia.',
  author: 'María G.'
}, {
  quote: 'Lo mejor es que no es una dieta restrictiva. Son hábitos reales que puedo mantener.',
  author: 'Ana L.'
}, {
  quote: 'Tenía miedo de gastar en otro producto que no funcionara. Pero por US$ 6.36, no tenía nada que perder.',
  author: 'Rosa V.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function TestimonialsSection() {
  return <section className="bg-wellness-light-sage py-20 px-6" id="testimonials" data-id="element-164">
      <div className="max-w-5xl mx-auto" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-wellness-dark mb-4" data-id="element-167">
            Lo que dicen quienes ya la probaron
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-168">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-6 shadow-sm" data-id="element-169">
              <div className="flex items-center justify-between mb-4" data-id="element-170">
                <div className="flex gap-0.5" data-id="element-171">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-wellness-gold text-wellness-gold" data-id="element-172" />)}
                </div>
                <span className="inline-flex items-center gap-1 text-xs text-wellness-green bg-wellness-light-sage px-2 py-1 rounded-full" data-id="element-173">
                  <BadgeCheck className="w-3 h-3" data-id="element-174" />
                  Verificada
                </span>
              </div>

              <p className="text-wellness-dark/80 italic mb-4" data-id="element-175">
                "{testimonial.quote}"
              </p>

              <p className="font-bold text-wellness-dark text-sm" data-id="element-176">
                — {testimonial.author}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}